// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3kQkp","validationTips":"StatementDescriptor_validationTips__30dLl"};